import * as C from "react";
import t from "react";
import { c as D, t as U } from "./app-a75c1d35.mjs";
import { b as $, f as H, j as s, g as G, P as y, c as K, h as me, u as z, i as ue, a as fe, e as ge } from "./index-099c513a.mjs";
import { I as ve, W as Ce } from "./Icon-3122c134.mjs";
import { ArticleSection as he } from "./ArticleSection.js";
import { I as be } from "./Image-d6406817.mjs";
import { B as R } from "./Block-9b78bd10.mjs";
import "react-dom";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
var P = "Collapsible", [xe, Y] = $(P), [Ae, L] = xe(P), J = C.forwardRef(
  (e, c) => {
    const {
      __scopeCollapsible: o,
      open: a,
      defaultOpen: r,
      disabled: n,
      onOpenChange: i,
      ...l
    } = e, [m, u] = H({
      prop: a,
      defaultProp: r ?? !1,
      onChange: i,
      caller: P
    });
    return /* @__PURE__ */ s.jsx(
      Ae,
      {
        scope: o,
        disabled: n,
        contentId: G(),
        open: m,
        onOpenToggle: C.useCallback(() => u((v) => !v), [u]),
        children: /* @__PURE__ */ s.jsx(
          y.div,
          {
            "data-state": V(m),
            "data-disabled": n ? "" : void 0,
            ...l,
            ref: c
          }
        )
      }
    );
  }
);
J.displayName = P;
var Q = "CollapsibleTrigger", X = C.forwardRef(
  (e, c) => {
    const { __scopeCollapsible: o, ...a } = e, r = L(Q, o);
    return /* @__PURE__ */ s.jsx(
      y.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": V(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...a,
        ref: c,
        onClick: K(e.onClick, r.onOpenToggle)
      }
    );
  }
);
X.displayName = Q;
var q = "CollapsibleContent", Z = C.forwardRef(
  (e, c) => {
    const { forceMount: o, ...a } = e, r = L(q, e.__scopeCollapsible);
    return /* @__PURE__ */ s.jsx(me, { present: o || r.open, children: ({ present: n }) => /* @__PURE__ */ s.jsx(Ie, { ...a, ref: c, present: n }) });
  }
);
Z.displayName = q;
var Ie = C.forwardRef((e, c) => {
  const { __scopeCollapsible: o, present: a, children: r, ...n } = e, i = L(q, o), [l, m] = C.useState(a), u = C.useRef(null), v = z(c, u), g = C.useRef(0), x = g.current, b = C.useRef(0), f = b.current, A = i.open || l, I = C.useRef(A), N = C.useRef(void 0);
  return C.useEffect(() => {
    const d = requestAnimationFrame(() => I.current = !1);
    return () => cancelAnimationFrame(d);
  }, []), ue(() => {
    const d = u.current;
    if (d) {
      N.current = N.current || {
        transitionDuration: d.style.transitionDuration,
        animationName: d.style.animationName
      }, d.style.transitionDuration = "0s", d.style.animationName = "none";
      const E = d.getBoundingClientRect();
      g.current = E.height, b.current = E.width, I.current || (d.style.transitionDuration = N.current.transitionDuration, d.style.animationName = N.current.animationName), m(a);
    }
  }, [i.open, a]), /* @__PURE__ */ s.jsx(
    y.div,
    {
      "data-state": V(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !A,
      ...n,
      ref: v,
      style: {
        "--radix-collapsible-content-height": x ? `${x}px` : void 0,
        "--radix-collapsible-content-width": f ? `${f}px` : void 0,
        ...e.style
      },
      children: A && r
    }
  );
});
function V(e) {
  return e ? "open" : "closed";
}
var Ne = J, Ee = X, ye = Z, h = "Accordion", Re = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [B, _e, Pe] = fe(h), [w, xo] = $(h, [
  Pe,
  Y
]), F = Y(), ee = t.forwardRef(
  (e, c) => {
    const { type: o, ...a } = e, r = a, n = a;
    return /* @__PURE__ */ s.jsx(B.Provider, { scope: e.__scopeAccordion, children: o === "multiple" ? /* @__PURE__ */ s.jsx(Te, { ...n, ref: c }) : /* @__PURE__ */ s.jsx(je, { ...r, ref: c }) });
  }
);
ee.displayName = h;
var [oe, we] = w(h), [te, Me] = w(
  h,
  { collapsible: !1 }
), je = t.forwardRef(
  (e, c) => {
    const {
      value: o,
      defaultValue: a,
      onValueChange: r = () => {
      },
      collapsible: n = !1,
      ...i
    } = e, [l, m] = H({
      prop: o,
      defaultProp: a ?? "",
      onChange: r,
      caller: h
    });
    return /* @__PURE__ */ s.jsx(
      oe,
      {
        scope: e.__scopeAccordion,
        value: t.useMemo(() => l ? [l] : [], [l]),
        onItemOpen: m,
        onItemClose: t.useCallback(() => n && m(""), [n, m]),
        children: /* @__PURE__ */ s.jsx(te, { scope: e.__scopeAccordion, collapsible: n, children: /* @__PURE__ */ s.jsx(ne, { ...i, ref: c }) })
      }
    );
  }
), Te = t.forwardRef((e, c) => {
  const {
    value: o,
    defaultValue: a,
    onValueChange: r = () => {
    },
    ...n
  } = e, [i, l] = H({
    prop: o,
    defaultProp: a ?? [],
    onChange: r,
    caller: h
  }), m = t.useCallback(
    (v) => l((g = []) => [...g, v]),
    [l]
  ), u = t.useCallback(
    (v) => l((g = []) => g.filter((x) => x !== v)),
    [l]
  );
  return /* @__PURE__ */ s.jsx(
    oe,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: m,
      onItemClose: u,
      children: /* @__PURE__ */ s.jsx(te, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ s.jsx(ne, { ...n, ref: c }) })
    }
  );
}), [Se, M] = w(h), ne = t.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, disabled: a, dir: r, orientation: n = "vertical", ...i } = e, l = t.useRef(null), m = z(l, c), u = _e(o), g = ge(r) === "ltr", x = K(e.onKeyDown, (b) => {
      if (!Re.includes(b.key))
        return;
      const f = b.target, A = u().filter((O) => !O.ref.current?.disabled), I = A.findIndex((O) => O.ref.current === f), N = A.length;
      if (I === -1)
        return;
      b.preventDefault();
      let d = I;
      const E = 0, j = N - 1, T = () => {
        d = I + 1, d > j && (d = E);
      }, S = () => {
        d = I - 1, d < E && (d = j);
      };
      switch (b.key) {
        case "Home":
          d = E;
          break;
        case "End":
          d = j;
          break;
        case "ArrowRight":
          n === "horizontal" && (g ? T() : S());
          break;
        case "ArrowDown":
          n === "vertical" && T();
          break;
        case "ArrowLeft":
          n === "horizontal" && (g ? S() : T());
          break;
        case "ArrowUp":
          n === "vertical" && S();
          break;
      }
      const pe = d % N;
      A[pe].ref.current?.focus();
    });
    return /* @__PURE__ */ s.jsx(
      Se,
      {
        scope: o,
        disabled: a,
        direction: r,
        orientation: n,
        children: /* @__PURE__ */ s.jsx(B.Slot, { scope: o, children: /* @__PURE__ */ s.jsx(
          y.div,
          {
            ...i,
            "data-orientation": n,
            ref: m,
            onKeyDown: a ? void 0 : x
          }
        ) })
      }
    );
  }
), _ = "AccordionItem", [Oe, W] = w(_), ae = t.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, value: a, ...r } = e, n = M(_, o), i = we(_, o), l = F(o), m = G(), u = a && i.value.includes(a) || !1, v = n.disabled || e.disabled;
    return /* @__PURE__ */ s.jsx(
      Oe,
      {
        scope: o,
        open: u,
        disabled: v,
        triggerId: m,
        children: /* @__PURE__ */ s.jsx(
          Ne,
          {
            "data-orientation": n.orientation,
            "data-state": de(u),
            ...l,
            ...r,
            ref: c,
            disabled: v,
            open: u,
            onOpenChange: (g) => {
              g ? i.onItemOpen(a) : i.onItemClose(a);
            }
          }
        )
      }
    );
  }
);
ae.displayName = _;
var re = "AccordionHeader", ce = t.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, ...a } = e, r = M(h, o), n = W(re, o);
    return /* @__PURE__ */ s.jsx(
      y.h3,
      {
        "data-orientation": r.orientation,
        "data-state": de(n.open),
        "data-disabled": n.disabled ? "" : void 0,
        ...a,
        ref: c
      }
    );
  }
);
ce.displayName = re;
var k = "AccordionTrigger", ie = t.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, ...a } = e, r = M(h, o), n = W(k, o), i = Me(k, o), l = F(o);
    return /* @__PURE__ */ s.jsx(B.ItemSlot, { scope: o, children: /* @__PURE__ */ s.jsx(
      Ee,
      {
        "aria-disabled": n.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: n.triggerId,
        ...l,
        ...a,
        ref: c
      }
    ) });
  }
);
ie.displayName = k;
var se = "AccordionContent", le = t.forwardRef(
  (e, c) => {
    const { __scopeAccordion: o, ...a } = e, r = M(h, o), n = W(se, o), i = F(o);
    return /* @__PURE__ */ s.jsx(
      ye,
      {
        role: "region",
        "aria-labelledby": n.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...a,
        ref: c,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
le.displayName = se;
function de(e) {
  return e ? "open" : "closed";
}
var De = ee, ke = ae, He = ce, Le = ie, qe = le;
const Ve = "faqAccordion", Be = "faqAccordionContent", Fe = "title", We = "intro", Ue = "imageWrapper", $e = "image", Ge = "introText", Ke = "accordionRoot", ze = "accordionItem", Ye = "accordionHeader", Je = "accordionTrigger", Qe = "heading", Xe = "chevron", Ze = "accordionContent", eo = "slideDown", oo = "slideUp", to = "body", no = "openMode", ao = "openItem", ro = "openHeading", co = "openBody", io = "articleMode", p = {
  faqAccordion: Ve,
  faqAccordionContent: Be,
  title: Fe,
  intro: We,
  imageWrapper: Ue,
  image: $e,
  introText: Ge,
  accordionRoot: Ke,
  accordionItem: ze,
  accordionHeader: Ye,
  accordionTrigger: Je,
  heading: Qe,
  chevron: Xe,
  accordionContent: Ze,
  slideDown: eo,
  slideUp: oo,
  body: to,
  openMode: no,
  openItem: ao,
  openHeading: ro,
  openBody: co,
  articleMode: io
};
function so({ item: e }) {
  return /* @__PURE__ */ t.createElement(ke, { value: e.id, className: p.accordionItem }, /* @__PURE__ */ t.createElement(He, { className: p.accordionHeader }, /* @__PURE__ */ t.createElement(Le, { className: p.accordionTrigger }, /* @__PURE__ */ t.createElement("span", { className: p.heading }, e.heading), /* @__PURE__ */ t.createElement(ve, { icon: Ce.CHEVRON_DOWN, className: p.chevron, size: 24, "aria-hidden": !0 }))), /* @__PURE__ */ t.createElement(qe, { className: p.accordionContent }, /* @__PURE__ */ t.createElement("div", { className: p.body }, e.body)));
}
function Ao({
  id: e,
  title: c,
  introText: o,
  image: a,
  imageAlt: r,
  items: n,
  mode: i,
  defaultOpen: l = !1,
  className: m
}) {
  const u = i === "accordion" || i === "faq", v = i === "open", g = i === "article", x = l && n.length > 0 ? n[0].id : void 0, b = o || a;
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    R,
    {
      id: e,
      as: "section",
      topPadding: R.Padding.SMALL,
      bottomPadding: R.Padding.SMALL,
      className: D(p.faqAccordion, m),
      "data-testid": "faq-accordion"
    },
    /* @__PURE__ */ t.createElement(R.Content, { className: p.faqAccordionContent, flex: !0 }, c && /* @__PURE__ */ t.createElement("h2", { className: D(p.title, U.headingSection) }, c), b && /* @__PURE__ */ t.createElement("div", { className: p.intro }, a && !g && /* @__PURE__ */ t.createElement("div", { className: p.imageWrapper }, /* @__PURE__ */ t.createElement(
      be,
      {
        src: a.imageSrc,
        width: a.width,
        height: a.height,
        altText: r || "",
        imageLoader: a.imageLoader,
        className: p.image
      }
    )), o && /* @__PURE__ */ t.createElement("p", { className: D(p.introText, U.textsLeadText) }, o)), v && /* @__PURE__ */ t.createElement("div", { className: p.openMode }, n.map((f) => /* @__PURE__ */ t.createElement("div", { key: f.id, className: p.openItem }, /* @__PURE__ */ t.createElement("div", { className: p.openHeading }, f.heading), /* @__PURE__ */ t.createElement("div", { className: p.openBody }, f.body)))), u && /* @__PURE__ */ t.createElement(
      De,
      {
        type: "single",
        collapsible: !0,
        defaultValue: x,
        className: p.accordionRoot
      },
      n.map((f) => /* @__PURE__ */ t.createElement(so, { key: f.id, item: f }))
    ))
  ), g && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: p.articleMode }, n.map((f) => /* @__PURE__ */ t.createElement(
    he,
    {
      key: f.id,
      heading: f.heading,
      bodyText: f.body
    }
  )))));
}
export {
  Ao as FaqAccordion
};
//# sourceMappingURL=FaqAccordion.js.map
